import { ResetStateAction } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { CurbLinkRecord, RegulationLinkRecord } from "../../../interfaces/CurbLink";
import { ProposedLinkRecord } from "../../../interfaces/ProposedLink";
import { ProposedRegulationBody, ProposedRegulationId } from "../types";
import { dividedLinkDataInterface, getDividedLinkDataInterface } from "./helpers";

export const CREATE_PROPOSED_CHANGE = "CREATE_PROPOSED_CHANGE";
export const CREATE_PROPOSED_LINK = "CREATE_PROPOSED_LINK";
export const CREATE_PROPOSED_REGULATION = "CREATE_PROPOSED_REGULATION";
export const CREATED_REGULATION_RECEIVED = "CREATED_REGULATION_RECEIVED";
export const GET_DIVIDED_LINK = "GET_DIVIDED_LINK";
export const IS_TOAST_POPUP_ENABLED = "IS_TOAST_POPUP_ENABLED";
export const IS_TOAST_POPUP_ENABLED_FOUR = "IS_TOAST_POPUP_ENABLED_FOUR";
export const IS_TOAST_POPUP_ENABLED_THREE = "IS_TOAST_POPUP_ENABLED_THREE";
export const IS_TOAST_POPUP_ENABLED_TWO = "IS_TOAST_POPUP_ENABLED_TWO";
export const POST_PROPOSED_REGULATION_LINKS = "POST_PROPOSED_REGULATION_LINKS";
export const PROPOSED_LINK_CREATED = "PROPOSED_LINK_CREATED";
export const RECEIVED_DIVIDED_LINK = "RECEIVED_DIVIDED_LINK";
export const SET_HOVERED_SEGMENT_TO_BE_CREATED = "SET_HOVERED_SEGMENT_TO_BE_CREATED";
export const SET_SEGMENTS_TO_BE_CREATED = "SET_SEGMENTS_TO_BE_CREATED";
export const STORE_ADJACENT_LINKS = "STORE_ADJACENT_LINKS";
export const STORE_PROPOSED_ADJACENT_LINKS = "STORE_PROPOSED_ADJACENT_LINKS";
export const TOGGLE_CREATE_OPTIONS_PANEL = "TOGGLE_CREATE_OPTIONS_PANEL";
export const TOGGLE_SCENARIO_PANEL = "TOGGLE_SCENARIO_PANEL";
export const TOGGLE_PROJECT_PANEL = "TOGGLE_PROJECT_PANEL";
export const TOGGLE_CREATE_REGULATION_PANEL = "TOGGLE_CREATE_REGULATION_PANEL";
export const TOGGLE_CUSTOM_SEGMENT_POPUP = "TOGGLE_CUSTOM_SEGMENT_POPUP";
export const TOGGLE_DRAW_CUSTOM_GROUP = "TOGGLE_DRAW_CUSTOM_GROUP";
export const SET_CUSTOM_GROUP_SEGMENTS_TO_BE_HIGHTLIGHTED =
    "SET_CUSTOM_GROUP_SEGMENTS_TO_BE_HIGHTLIGHTED";
export const STORE_TO_BE_CREATED_CUSTOM_GROUP_SEGMENTS =
    "STORE_TO_BE_CREATED_CUSTOM_GROUP_SEGMENTS";
export const STORE_TO_BE_CONFIRMED_CUSTOM_GROUP_SEGMENTS =
    "STORE_TO_BE_CONFIRMED_CUSTOM_GROUP_SEGMENTS";

export type afterSaveFunc = (regulationId: ProposedRegulationId) => void;
export type CustomGroupSegmentsToBeHighlighted = { [prop: number]: CurbLinkRecord };
export type HoveredSegmentToBeCreated = { [prop: number]: CurbLinkRecord };
export type IsCreateOptionsPanelOpen = boolean;
export type IsCreateRegulationPanelOpen = boolean;
export type IsDrawCustomGroupEnabled = boolean;
export type IsToastPopupEnabled = boolean;
export type IsToastPopupEnabledFour = boolean;
export type IsToastPopupEnabledThree = boolean;
export type IsToastPopupEnabledTwo = boolean;
export type ProposedRegulationLinksBody = RegulationLinkRecord;
export type SegmentsToBeCreated = { [prop: number]: CurbLinkRecord };

export type ArrayLatLngType = [number, number];

// Create Custom Group Segment is an dictionary with value as stack implemented as array //remove
export type ToBeCreatedCustomGroupSegments = {
    [prop: number]: Array<
        [{ actualCoordinate: ArrayLatLngType; nearestCoordinate: ArrayLatLngType; index: number }]
    >;
};

export type ToBeConfirmedCustomGroupSegments = Map<number, Map<string, CurbLinkRecord>>;

export interface ToggleCreateRegulationPanelAction {
    type: typeof TOGGLE_CREATE_REGULATION_PANEL;
    payload: { isCreateRegulationPanelOpen: IsCreateRegulationPanelOpen };
}

export interface ToggleCreateOptionsPanel {
    type: typeof TOGGLE_CREATE_OPTIONS_PANEL;
    payload: { isCreateOptionsPanelOpen: IsCreateOptionsPanelOpen };
}

export interface ToggleProjectPanel {
    type: typeof TOGGLE_PROJECT_PANEL;
    payload: {
        isProjectPanelOpen: boolean;
    };
}

export interface ToggleDrawCustomGroupAction {
    type: typeof TOGGLE_DRAW_CUSTOM_GROUP;
    payload: { isDrawCustomGroupEnabled: IsDrawCustomGroupEnabled };
}

export interface ToggleToastPopupEnabledAction {
    type: typeof IS_TOAST_POPUP_ENABLED;
    payload: { isToastPopupEnabled: IsToastPopupEnabled };
}

export interface ToggleToastPopupEnabledTwoAction {
    type: typeof IS_TOAST_POPUP_ENABLED_TWO;
    payload: { isToastPopupTwoEnabled: IsToastPopupEnabledTwo };
}

export interface ToggleToastPopupEnabledThreeAction {
    type: typeof IS_TOAST_POPUP_ENABLED_THREE;
    payload: { isToastPopupThreeEnabled: IsToastPopupEnabledThree };
}

export interface ToggleToastPopupEnabledFourAction {
    type: typeof IS_TOAST_POPUP_ENABLED_FOUR;
    payload: { isToastPopupFourEnabled: IsToastPopupEnabledFour };
}

export interface SetSegmentsToBeCreatedAction {
    type: typeof SET_SEGMENTS_TO_BE_CREATED;
    payload: { segmentsToBeCreated: SegmentsToBeCreated };
}

export interface SetHoveredSegmentToBeCreateAction {
    type: typeof SET_HOVERED_SEGMENT_TO_BE_CREATED;
    payload: { hoveredSegmentToBeCreated: HoveredSegmentToBeCreated };
}

export interface SetCustomGroupSegmentsToBeHighlightedAction {
    type: typeof SET_CUSTOM_GROUP_SEGMENTS_TO_BE_HIGHTLIGHTED;
    payload: { customGroupSegmentsToBeHighlighted: CustomGroupSegmentsToBeHighlighted };
}

export interface CreateProposedRegulationAction {
    type: typeof CREATE_PROPOSED_REGULATION;
    payload: { proposedRegulationBody: ProposedRegulationBody; afterSave: afterSaveFunc };
}

export interface CreatedRegulationReceivedAction {
    type: typeof CREATED_REGULATION_RECEIVED;
    payload: { data: boolean };
}

export interface CreateProposedRegulationLinksAction {
    type: typeof POST_PROPOSED_REGULATION_LINKS;
    payload: { regulationLinksBody: ProposedRegulationLinksBody };
}

export interface StoreToBeCreatedCustomGroupSegmentsAction {
    type: typeof STORE_TO_BE_CREATED_CUSTOM_GROUP_SEGMENTS;
    payload: { toBeCreatedCustomGroupSegments: ToBeCreatedCustomGroupSegments };
}

export interface StoreToBeConfirmedCustomGroupSegmentsAction {
    type: typeof STORE_TO_BE_CONFIRMED_CUSTOM_GROUP_SEGMENTS;
    payload: { toBeConfirmedCustomGroupSegments: ToBeConfirmedCustomGroupSegments };
}

export interface CreateProposedLinkAction {
    type: typeof CREATE_PROPOSED_LINK;
    payload: { proposedLinkToCreate: ProposedLinkRecord };
}

export interface ProposedLinkCreatedAction {
    type: typeof PROPOSED_LINK_CREATED;
    payload: { proposedLinkCreatedData: ProposedLinkRecord };
}
export interface GetDividedLinkAction {
    type: typeof GET_DIVIDED_LINK;
    payload: getDividedLinkDataInterface;
}

export interface ReceivedDividedLinkAction {
    type: typeof RECEIVED_DIVIDED_LINK;
    payload: { data: dividedLinkDataInterface | null };
}

export interface createProposedChangeAction {
    type: typeof CREATE_PROPOSED_CHANGE;
    payload: { data: object; afterProcess?: () => void };
}

export interface storeAdjacentLinksAction {
    type: typeof STORE_ADJACENT_LINKS;
    payload: { data: object | null };
}

export interface storeProposedAdjacentLinksAction {
    type: typeof STORE_PROPOSED_ADJACENT_LINKS;
    payload: { data: object | null };
}

export type CreateRegulationTypes =
    | CreatedRegulationReceivedAction
    | createProposedChangeAction
    | CreateProposedLinkAction
    | CreateProposedRegulationAction
    | CreateProposedRegulationLinksAction
    | GetDividedLinkAction
    | ProposedLinkCreatedAction
    | ReceivedDividedLinkAction
    | SetCustomGroupSegmentsToBeHighlightedAction
    | SetHoveredSegmentToBeCreateAction
    | SetSegmentsToBeCreatedAction
    | storeAdjacentLinksAction
    | storeProposedAdjacentLinksAction
    | StoreToBeConfirmedCustomGroupSegmentsAction
    | StoreToBeCreatedCustomGroupSegmentsAction
    | ToggleCreateOptionsPanel
    | ToggleCreateRegulationPanelAction
    | ToggleDrawCustomGroupAction
    | ToggleToastPopupEnabledAction
    | ToggleToastPopupEnabledFourAction
    | ToggleToastPopupEnabledThreeAction
    | ToggleToastPopupEnabledTwoAction
    | ResetStateAction
    | ToggleProjectPanel;

export interface CreateRegulationState {
    adjacentLinks: object | null;
    createdRegulationData: boolean;
    customGroupSegmentsToBeHighlighted: CustomGroupSegmentsToBeHighlighted;
    dividedLinkData: dividedLinkDataInterface | null;
    hoveredSegmentToBeCreated: HoveredSegmentToBeCreated;
    isCreateOptionsPanelOpen: IsCreateOptionsPanelOpen;
    isCreateRegulationPanelOpen: IsCreateRegulationPanelOpen;
    isDrawCustomGroupEnabled: IsDrawCustomGroupEnabled;
    isToastPopupEnabled: IsToastPopupEnabled;
    isToastPopupEnabledFour: IsToastPopupEnabledFour;
    isToastPopupEnabledThree: IsToastPopupEnabledThree;
    isToastPopupEnabledTwo: IsToastPopupEnabledTwo;
    proposedAdjacentLinks: object | null;
    proposedLinkCreatedData: ProposedLinkRecord;
    proposedLinkToCreate: ProposedLinkRecord;
    segmentsToBeCreated: SegmentsToBeCreated;
    toBeConfirmedCustomGroupSegments: ToBeConfirmedCustomGroupSegments;
    toBeCreatedCustomGroupSegments: ToBeCreatedCustomGroupSegments;
    isProjectPanelOpen: boolean;
}
